import { type CbhIconProps, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { PaymentDetailsLineItem } from "./PaymentDetailsLineItem";

export interface PaymentDetailsAdjustmentLineItemProps {
  iconType: CbhIconProps["type"];
  label: string;
  newValue: string;
  oldValue: string;
  difference: string;
  differenceType: "positive" | "negative";
}

export function PaymentDetailsAdjustmentLineItem(props: PaymentDetailsAdjustmentLineItemProps) {
  const { iconType, label, newValue, oldValue, difference, differenceType } = props;

  return (
    <PaymentDetailsLineItem
      iconType={iconType}
      label={label}
      value={
        <Text
          semibold
          sx={(theme) => ({
            color:
              theme.palette.intent?.[differenceType === "positive" ? "success" : "error"]?.text,
          })}
        >
          {difference}
        </Text>
      }
      valueSecondLine={
        <Stack direction="row">
          <Text
            variant="caption"
            sx={{ color: (theme) => theme.palette.text.tertiary, textDecoration: "line-through" }}
          >
            {oldValue}
          </Text>
          <Text variant="caption">
            &nbsp;→&nbsp;
            {newValue}
          </Text>
        </Stack>
      }
    />
  );
}
